import { parse, stringify } from "query-string";
import { pageFeature } from "./PageFeatures";

const STORAGE_KEY = "in-dev-features";

class InDevFeatureFlags {
  static instance() {
    if (!this._instance) {
      this._instance = new InDevFeatureFlags();
    }
    return this._instance;
  }

  constructor(storage = GC.session) {
    this.storage = storage;
  }

  persistentFeature(featureName, onOff) {
    const features = this.persistentFeatures();
    if (onOff === true || onOff === false) {
      features[featureName] = onOff;
    } else {
      delete features[featureName];
    }
    GC.session.setItem(STORAGE_KEY, features);
  }

  isEnabled(featureName) {
    return this.persistentFeatures()[featureName];
  }

  persistentFeatures() {
    return this.storage.getItem(STORAGE_KEY) || {};
  }

  initPersistentFeatures() {
    const features = this.persistentFeatures();
    const featureNames = Object.keys(features);
    const enabledFeatures = [];

    for (let i = 0; i < featureNames.length; i++) {
      const name = featureNames[i];

      pageFeature(name, features[name]);

      if (features[name]) {
        enabledFeatures.push(name);
      }
    }

    this._addFlagsToQueryParameters(enabledFeatures);
  }

  _addFlagsToQueryParameters(enabledFeatures) {
    if (enabledFeatures.length === 0) {
      return;
    }

    document.querySelectorAll("a[href]").forEach((anchor) => {
      const existingParams = parse(anchor.search);
      existingParams.ff = enabledFeatures.join(",");

      anchor.href = `${anchor.protocol}//${anchor.host}${anchor.pathname}?${stringify(existingParams)}${anchor.hash}`;
    });
  }
}

export function initialiseInDevFeatures() {
  return new Promise((resolve) => {
    GlamCornerCore.bus.on("product-list-loaded", () => {
      InDevFeatureFlags.instance().initPersistentFeatures();
    });

    window.addEventListener("load", () => {
      InDevFeatureFlags.instance().initPersistentFeatures();
      resolve();
    });
  });
}

export default InDevFeatureFlags;
